import { ChangeEvent, useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import CommonModal from "../../components/CommonModal";
import { Email, Button } from "../../controls";
import { useStore } from "../../store";
import { isEmail } from "validator";
import { UserService } from "../../services";
import CopyRight from "../../components/CopyRight";
import Logo from "../../components/Logo";
import ThemeToggle from "../../components/ThemeToggle";

function ForgetPassword() {
  const [modalShow, setModalShow] = useState(false);
  const { setIsLoading } = useStore((s: any) => s);
  const [values, setValues] = useState({
    email: "",
  });
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: value,
      });
    },
    [values]
  );

  const hanldeSubmit = useCallback(
    async (e: any) => {
      e.preventDefault();
      if (!values?.email || !isEmail(values?.email))
        return setValidationMessage("Please provide a valid email address.");

      setIsLoading(true);
      let result = await UserService.forgotPassword(values);
      if (result?.error) {
        setIsLoading(false);
        setValidationMessage(result?.error);
        return;
      }

      setIsLoading(false);
      setModalShow(true);
    },
    [values, setIsLoading, setModalShow, setValidationMessage]
  );

  return (
    <>
      <div className="container">
        <div className="row h-100vh">
          <div className="col-md-5 loginLeft position-relative">
            <div className="d-flex align-items-center h-100 w-100">
              <div className="w-100">
                <div className="text-md-start text-center">
                  <Link to="/">
                    <Logo width={100} height={100} />
                  </Link>
                </div>
                <h1>Forgot your password?</h1>
                <p>
                  Enter your email address below and we'll send you a link to
                  reset your password
                </p>
                <div className="formMain">
                  <Form>
                    <Email value={values?.email} onChange={handleInputChange} />
                    {validationMessage && (
                      <div className="validation-message">
                        {validationMessage}
                      </div>
                    )}
                    <Button
                      title="Send verification link"
                      onClick={hanldeSubmit}
                    />
                  </Form>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <Link to="/login" className="goBack">
                    <img className="me-2" src="/assets/imgs/arrow.svg" alt="" />{" "}
                    Go Back
                  </Link>
                </div>
                <div className="authThemeToggle mt-4">
                  <ThemeToggle />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-6 position-relative">
            <div className="d-md-flex align-items-center h-100 d-none">
              <img
                src="/assets/imgs/forget-password.png"
                className="w-100"
                alt=""
              />
            </div>
            <CopyRight />
          </div>
        </div>
      </div>
      <CommonModal
        title="Reset your password"
        message="We have sent a password reset link to your email address."
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default ForgetPassword;
